import { render } from "./rewordModal.vue?vue&type=template&id=0ef826cf&scoped=true"
import script from "./rewordModal.vue?vue&type=script&lang=js"
export * from "./rewordModal.vue?vue&type=script&lang=js"

import "./rewordModal.vue?vue&type=style&index=0&id=0ef826cf&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ydsk-ph-h5-bankv3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ef826cf"]])

export default __exports__